"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    App: {
        baseUrl: 'http://localhost:3333/api',
    },
    Meeting: {
        domain: 'conf.v4h.cloud',
        externalApi: 'https://conf.v4h.cloud/external_api.js',
    },
};
exports.default = config;
